import { render } from "./PromoRive.vue?vue&type=template&id=0d40d1dc&scoped=true"
import script from "./PromoRive.vue?vue&type=script&lang=js"
export * from "./PromoRive.vue?vue&type=script&lang=js"

import "./PromoRive.vue?vue&type=style&index=0&id=0d40d1dc&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d40d1dc"]])

export default __exports__